// AdSense + Google's published Privacy & messaging CMP. No home-made consent UI.
type Commands={push:(value:Record<string,unknown>)=>unknown;pauseAdRequests?:number;requestNonPersonalizedAds?:number};
type ConsentValues={adStoragePurposeConsentStatus?:number;adUserDataPurposeConsentStatus?:number};
type FundingChoices={callbackQueue:{push:(entry:Record<string,()=>void>)=>unknown};getGoogleConsentModeValues?:()=>ConsentValues;showRevocationMessage?:()=>void};
declare global {interface Window {adsbygoogle?:Commands;googlefc?:FundingChoices}}
let boot:Promise<boolean>|undefined,consent=false,eligible=false,apiReady=false,choosing=false;
const listeners=new Set<()=>void>(),requested=new WeakSet<HTMLElement>();
const notify=()=>listeners.forEach(fn=>fn());
export const subscribeAdSense=(fn:()=>void)=>{listeners.add(fn);return()=>{listeners.delete(fn);};};
export const adSenseReady=()=>consent&&eligible;
export const adPrivacyReady=()=>apiReady;
function commands(){return window.adsbygoogle??=([] as unknown as Commands);}
function apply(){commands().pauseAdRequests=adSenseReady()?0:1;notify();}
export function setAdSenseEligibility(value:boolean){eligible=value;if(boot)apply();}
function readConsent(){
 try{const values=window.googlefc?.getGoogleConsentModeValues?.(),allowed=(value:number|undefined)=>value===1||value===3;consent=Boolean(!choosing&&values&&allowed(values.adStoragePurposeConsentStatus)&&allowed(values.adUserDataPurposeConsentStatus));}catch{consent=false;}
 apply();
}
export function loadAdSense(publisher:string):Promise<boolean>{
 if(!/^ca-pub-\d{16}$/.test(publisher))return Promise.resolve(false);
 if(boot)return boot;
 const ads=commands();ads.pauseAdRequests=1;
 // Launch uses non-personalized ads; storage/data consent is still required.
 ads.requestNonPersonalizedAds=1;
 const fc=window.googlefc??={callbackQueue:[] as Record<string,()=>void>[]};
 fc.callbackQueue??=[] as Record<string,()=>void>[];
 fc.callbackQueue.push({CONSENT_API_READY:()=>{apiReady=true;notify();
  const tcf=(window as Window&{__tcfapi?:(command:string,version:number,callback:(data:{eventStatus?:string},success:boolean)=>void)=>void}).__tcfapi;
  tcf?.('addEventListener',2,(data,success)=>{if(!success)return;choosing=data.eventStatus==='cmpuishown';if(choosing){consent=false;apply();}else setTimeout(readConsent,0);});
 },CONSENT_MODE_DATA_READY:readConsent});
 // Also reevaluate on a foreground visit, so changed consent is never cached as a grant.
 addEventListener('focus',readConsent);document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')readConsent();});
 boot=new Promise(resolve=>{
  const script=document.createElement('script');script.id='khojipark-adsense';script.async=true;script.crossOrigin='anonymous';
  const nonce=document.querySelector<HTMLScriptElement>('script[nonce]')?.nonce;if(nonce)script.nonce=nonce;
  script.src='https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client='+publisher;
  const timer=setTimeout(()=>{consent=false;apply();resolve(false);},8000);
  script.onload=()=>{clearTimeout(timer);resolve(true);};script.onerror=()=>{clearTimeout(timer);consent=false;apply();resolve(false);};
  document.head.append(script);
 });return boot;
}
export function requestInFeed(element:HTMLElement){
 if(!adSenseReady()||!element.isConnected||element.getBoundingClientRect().width<250)return false;
 if(requested.has(element))return true;
 // StrictMode, resizing and language changes must not refresh an existing ad.
 requested.add(element);
 try{commands().push({});return true;}catch{return false;}
}
export function openAdPrivacy(){
 if(!apiReady||typeof window.googlefc?.showRevocationMessage!=='function')return false;
 choosing=true;consent=false;apply();
 window.googlefc.callbackQueue.push({CONSENT_API_READY:()=>window.googlefc?.showRevocationMessage?.()});
 return true;
}
export async function ensureAdPrivacy(publisher:string){
 // Privacy pages can load only the paused SDK/CMP on an explicit user action.
 // No slot or ad request is needed to revisit a consent choice.
 const origin=location.href;
 if(!await loadAdSense(publisher)||!window.googlefc||location.href!==origin)return false;
 return new Promise<boolean>(resolve=>{
  let waiting=true;const timer=setTimeout(()=>{waiting=false;resolve(false);},8000);
  window.googlefc!.callbackQueue.push({CONSENT_API_READY:()=>{if(!waiting)return;waiting=false;clearTimeout(timer);resolve(location.href===origin&&document.visibilityState==='visible'&&openAdPrivacy());}});
 });
}
